// extracted by mini-css-extract-plugin
module.exports = {"hintDashboardContainer":"HintDashBoard_hintDashboardContainer__xrwpl","hintDashboardCard":"HintDashBoard_hintDashboardCard__1kTJm"};